import { Box, ToggleButton } from "@mui/material";
import ToggleButtonGroup, { toggleButtonGroupClasses } from "@mui/material/ToggleButtonGroup";
import { NutritionColorIcon, TeamworksBadgeIcon } from "@notemeal/shared/ui/global/Icons";
import React, { useState } from "react";
import { HUB_CHECK_IN } from "../../views/Kiosk/utils";

export const TWTabGroup = ({
  buttons,
  onSelected,
  outsideSelected,
}: {
  buttons: string[];
  onSelected: (selected: string) => void;
  outsideSelected?: string;
}) => {
  const [selected, setSelected] = useState<string>(buttons[0]);
  const handleSelected = (selected: string) => {
    if (selected) {
      setSelected(selected);
      onSelected(selected);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <ToggleButtonGroup
        sx={{
          border: 1,
          borderColor: "#EAECF0",
          borderRadius: 1.5,
          backgroundColor: "#F8FAFB",
          [`& .${toggleButtonGroupClasses.grouped}`]: {
            border: 0,
            borderRadius: 1,
          },
        }}
        size="small"
        exclusive
        value={outsideSelected || selected}
        onChange={(e, value) => handleSelected(value)}
      >
        {buttons.map((button, index) => (
          <ToggleButton
            key={button}
            sx={{
              m: 0.25,
              px: 2,
              py: 0.75,
              fontSize: 14,
              fontWeight: 600,
              backgroundColor: "#F8FAFB",
              "&.Mui-selected": {
                boxShadow: 1,
                border: 1,
                borderColor: "#EAECF0",
                backgroundColor: "white",
              },
            }}
            value={button}
          >
            {button === HUB_CHECK_IN && (
              <>
                <TeamworksBadgeIcon sx={{ marginRight: 0.5 }} /> x <NutritionColorIcon sx={{ marginRight: 1, marginLeft: 0.5 }} />
              </>
            )}
            {button}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};
